import axios from '../Backend';

export const addChatToGroup = async (uniqGroupName,clientName,msgType,isForward) => {
    try {
        const bodyObj={
            uniqGroupName,
            clientName,
            msgType,
            isForward
        }
        await axios.post('/group/addChatToGroup', bodyObj);
    } catch (e) {
        console.log('axios/groupsReq/addChatToGroup :: Error')
        console.log(JSON.stringify(e.response.data))
    }
}

export const removeChatFromGroup = async (uniqGroupName,clientName,msgType) => {
    try {
        const bodyObj={
            uniqGroupName,
            clientName,
            msgType
        }
        await axios.put('/group/removeChatFromGroup', bodyObj);
    } catch (e) {
        console.log('axios/groupsReq/addChatToGroup :: Error')
        console.log(JSON.stringify(e.response.data))
    }
}

export const addNewGroup = async (uniqGroupName,groupName) => {
    try {
        const bodyObj={
            uniqGroupName,
            groupName
        }
        await axios.post('/group/grouplist', bodyObj);
    } catch (e) {
        console.log('axios/groupsReq/addChatToGroup :: Error')
        console.log(JSON.stringify(e.response.data))
    }
}

export const removeGroup = async (uniqGroupName) => {
    try {
        const bodyObj={
            uniqGroupName
        }
        await axios.put('/group/removegroup', bodyObj);
    } catch (e) {
        console.log('axios/groupsReq/addChatToGroup :: Error')
        console.log(JSON.stringify(e.response.data))
    }
}

export const group_add_agent_byname = async (uniqGroupName,agentName) => {
    try {
        const bodyObj={
            uniqGroupName,
            agentName
        }
        await axios.post('/group/addagent_byname', bodyObj);
    } catch (e) {
        console.log('axios/groupsReq/addChatToGroup :: Error')
        console.log(JSON.stringify(e.response.data))
    }
}

export const group_remove_agent_byname = async (uniqGroupName,agentName) => {
    try {
        const bodyObj={
            uniqGroupName,
            agentName
        }
        await axios.put('/group/removeagent_byname', bodyObj);
    } catch (e) {
        console.log('axios/groupsReq/addChatToGroup :: Error')
        console.log(JSON.stringify(e.response.data))
    }
}

